import React, { useState, useEffect, useContext } from 'react'
import ReactDOM from 'react-dom'

import { withStyles, makeStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Button from '@material-ui/core/Button'
import ArrowRightOutlinedIcon from '@material-ui/icons/ArrowRightOutlined'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ReplayIcon from '@material-ui/icons/Replay'
import Slider from '@material-ui/core/Slider'
import OfflineBoltIcon from '@material-ui/icons/OfflineBolt'
import Grow from '@material-ui/core/Grow'

import Checkbox from '@material-ui/core/Checkbox'
import ToggleOffOutlinedIcon from '@material-ui/icons/ToggleOffOutlined'
import ToggleOnOutlinedIcon from '@material-ui/icons/ToggleOnOutlined'
import './saaviSlider.css'

import { SeasonSlider } from './season'
// import { WinterSlider } from './winter'

// import './Interconnection.css'

const useStyles = makeStyles({
  root: {
    width: 150,
    color: '#c2c6cc',
    marginLeft: '20px',
  },
  btn: {
    boxShadow: 'none',
    color: '#a65e44',
    borderColor: '#a65e44',
    '&:hover': {
      backgroundColor: '#a65e441A',
      borderColor: '#a65e44',
      boxShadow: 'none',
    },
  },
})

function Interconnections(props) {
  const [screenHeight, setScreenHeight] = useState(228)
  const [screenHeightTxt, setScreenHeightTxt] = useState('228px')
  const [sliderCPSummer, setSliderCPSummer] = useState([40, 50])
  const [sliderCPWinter, setSliderCPWinter] = useState([30, 45])
  const [sliderLMPSummer, setSliderLMPSummer] = useState([40, 50])
  const [sliderLMPWinter, setSliderLMPWinter] = useState([30, 45])

  const [sliderNCPSummer, setSliderNCPSummer] = useState([-0.25, 2.75])
  const [sliderNCPWinter, setSliderNCPWinter] = useState([-4.75, 3.0])

  const classes = useStyles()

  useEffect(() => {
    if (window.innerHeight <= 850) {
      setScreenHeight(166)
      setScreenHeightTxt('200px')
    }
  }, [])

  const sliderCongestionS = (event, newValue) => {
    setSliderCPSummer(newValue)
  }

  const sliderCongestionW = (event, newValue) => {
    setSliderCPWinter(newValue)
  }

  const sliderLMPS = (event, newValue) => {
    setSliderLMPSummer(newValue)
  }

  const sliderLMPW = (event, newValue) => {
    setSliderLMPWinter(newValue)
  }

  const sliderCongestionNodeS = (event, newValue) => {
    setSliderNCPSummer(newValue)
  }

  const sliderCongestionNodeW = (event, newValue) => {
    setSliderNCPWinter(newValue)
  }

  const generalHeatmap = (min, max, id) => {
    // console.log(id)
    const item = [...props.layerData]
    const dif = (max - min) / 6
    const colorScale = [
      [255, 0, 0],
      [255, 94, 0],
      [255, 162, 0],
      [255, 230, 0],
      [225, 255, 0],
      [174, 255, 0],
      [0, 255, 0],
    ]
    const busNum = [[min], [min + dif], [min + dif * 2], [min + dif * 3], [min + dif * 4], [min + dif * 5], [max]]
    // console.log(busNum)
    // console.log(min + '-' + max)
    const layerData = item.filter((obj) => obj.layer == id[0].section)

    id.map((val) => {
      // console.log(layerData.find((obj) => obj.id == val.id))
      layerData
        .find((obj) => obj.id == val.id)
        .data.map((obj) => {
          if (!obj.heatmap && obj.heatmap == null) obj.specificDesign.color = [255, 255, 255, 20]
          if (obj.heatmap && obj.heatmap <= min) obj.specificDesign.color = colorScale[0]
          if (obj.heatmap && obj.heatmap > min && obj.heatmap <= busNum[1]) obj.specificDesign.color = colorScale[1]
          if (obj.heatmap && obj.heatmap > busNum[1] && obj.heatmap <= busNum[2])
            obj.specificDesign.color = colorScale[2]
          if (obj.heatmap && obj.heatmap > busNum[2] && obj.heatmap <= busNum[3])
            obj.specificDesign.color = colorScale[3]
          if (obj.heatmap && obj.heatmap > busNum[3] && obj.heatmap <= busNum[4])
            obj.specificDesign.color = colorScale[4]
          if (obj.heatmap && obj.heatmap > busNum[4] && obj.heatmap <= busNum[5])
            obj.specificDesign.color = colorScale[5]
          if (obj.heatmap && obj.heatmap >= busNum[5]) obj.specificDesign.color = colorScale[6]
        })
    })

    id.map((val) => {
      item.find((obj) => obj.id === val.id).data = layerData.find((obj) => obj.id == val.id).data
      item.find((obj) => obj.id === val.id).design.color = [255, 255, 255 * Math.random()]
    })

    props.setLayerData(item)
  }

  const showAllLayer = (name, season) => (event) => {
    if (name === "Saavi's Polygons") {
      let newArr = [...props.layerData]
      newArr.map((obj) => {
        obj.id === 'congestion_prices_polygon_no_filling' ? (obj.visible = event.target.checked) : obj
      })
      props.setLayerData(newArr)
    } else {
      const elems = document.getElementsByName(name)
      for (var i = 0; i < elems.length; i++) {
        if (!event.target.checked && elems[i].checked) elems[i].click()
        if (event.target.checked && !elems[i].checked) elems[i].click()
      }
    }
  }

  const turnOff = (name) => {
    // console.log("index: ", index, "\nname: ", name)
    const btn = document.getElementById(name)
    const elems = document.getElementsByName(name)
    for (var i = 0; i < elems.length; i++) {
      if (btn.checked) btn.click()
      if (elems[i].checked) elems[i].click()
    }
  }

  const checkBoxInterconnection = (index, subIndex) => (event) => {
    let newArr = [...props.sidebarData]
    let newArr2 = [...props.layerData]
    let season = newArr[props.layer].layers[index].season.toLowerCase()

    // console.log("FIND: ", props.sidebarData[props.layer].layers[index][props.clientName][season][subIndex].id)
    // console.log(newArr2.find(
    //       (obj) => obj.id === props.sidebarData[props.layer].layers[index][props.clientName][season][subIndex].id,
    //     ))

    newArr[props.layer].layers[index][props.clientName][season][subIndex].label =
      newArr[props.layer].layers[index][props.clientName][season][subIndex].label
    newArr[props.layer].layers[index][props.clientName][season][subIndex].show = event.target.checked

    if (newArr[props.layer].layers[index].hasOwnProperty(props.clientName)) {
      if ('id' in newArr[props.layer].layers[index][props.clientName][season][subIndex]) {
        newArr2.find(
          (obj) => obj.id === props.sidebarData[props.layer].layers[index][props.clientName][season][subIndex].id,
        ).visible = event.target.checked
      } else {
        console.log(
          'NO TIENE ID EL ELEMENTO',
          '\nLayer:',
          newArr[props.layer].layers[index].name,
          '\nLABEL:',
          newArr[props.layer].layers[index][props.clientName][season][subIndex].label,
        )
      }
    } else {
      console.log('CAPA SIN MULTICAPAS')
    }
    props.setLayerData(newArr2)
    props.setSidebarData(newArr)
  }

  const changeSeason = (index, name) => (event) => {
    // console.log(name)
    let newArr = [...props.sidebarData]
    let currentSeason = props.sidebarData[props.layer].layers[index].season.toLowerCase()
    if (currentSeason !== 'summer') {
      turnOff(name)
      newArr[props.layer].layers[index].season = 'Summer'
      props.setSidebarData(newArr)
    } else if (currentSeason !== 'winter') {
      turnOff(name)
      let newArr = [...props.sidebarData]
      newArr[props.layer].layers[index].season = 'Winter'
      props.setSidebarData(newArr)
    }
  }

  const expand = (layer) => {
    let newArr = [...props.sidebarData]
    if (layer.name !== "Saavi's Polygons") {
      newArr.map((obj) => {
        const i = obj.layers.findIndex((x) => x.name === layer.name)
        if (obj.title === 'Local Marginal Prices' && i > -1) {
          obj.layers.map((val) => {
            if (val.name === layer.name && val.style.height === '70px') {
              let height = val[props.clientName][Object.keys(val[props.clientName])[0]].length
              if (height !== 1) {
                height = screenHeight + height * 30 + 'px'
              } else {
                height = screenHeightTxt
              }
              val.style = { height: height, trn: 'rotate(90deg)' }
            } else if (val.name === layer.name && val.style.height !== '70px') {
              val.style = { height: '70px', trn: 'rotate(0deg)' }
            } else if (val.name !== layer.name) {
              val.style = { height: '70px', trn: 'rotate(0deg)' }
            }
          })
        }
      })
      props.setSidebarData(newArr)
    }
  }

  return (
    <Grow timeout={{ appear: 1000, enter: 1000, exit: 200 }} in={props.grow}>
      <div className="saavi-mc">
        <div className="ifr-title">
          <p className="ifr-title-txt" style={{ marginLeft: '6px' }}>
            {props.sidebarData[props.layer].title}
          </p>
        </div>
        <form className="form-container" action="">
          {props.conLayers.map((layer, index) => (
            <div className="plants-ifr" style={{ height: `${layer.style.height}`, overflow: 'hidden' }}>
              {layer.season && layer.season.toLowerCase() === 'summer' ? (
                <div className="season-btn-container">
                  <div
                    className="summer-btn"
                    style={{ background: '#d0cc2d' }}
                    onClick={changeSeason(index, layer.name)}
                  >
                    Summer
                  </div>
                  <div
                    className="winter-btn"
                    style={{ background: '#9d9d9d' }}
                    onClick={changeSeason(index, layer.name)}
                  >
                    Winter
                  </div>
                </div>
              ) : layer.season && layer.season.toLowerCase() === 'winter' ? (
                <div className="season-btn-container">
                  <div
                    className="summer-btn"
                    style={{ background: '#9d9d9d' }}
                    onClick={changeSeason(index, layer.name)}
                  >
                    Summer
                  </div>
                  <div
                    className="winter-btn"
                    style={{ background: '#002cff' }}
                    onClick={changeSeason(index, layer.name)}
                  >
                    Winter
                  </div>
                </div>
              ) : (
                <div className="season-btn-container" style={{ background: '#2b2b2b26' }} />
              )}

              <div style={{ display: 'flex', height: '50px' }}>
                {props.clientName in layer && layer.name !== "Saavi's Polygons" ? (
                  <ArrowRightOutlinedIcon
                    style={{ transform: `${layer.style.trn}` }}
                    className="plants-arrow"
                    onClick={() => expand(layer)}
                  />
                ) : (
                  <div className="plants-no-arrow" />
                )}

                {'season' in layer ? (
                  <label //name={layer.name}
                    className="ifr-lines-title"
                    onClick={() => expand(layer)}
                  >
                    {layer.name + layer.season}
                  </label>
                ) : (
                  <label //name={layer.name}
                    className="ifr-lines-title"
                    onClick={() => expand(layer)}
                  >
                    {layer.name}
                  </label>
                )}

                <FormControlLabel
                  style={{ marginRight: '-10px' }}
                  control={
                    <Checkbox
                      id={layer.name}
                      color="default"
                      onChange={showAllLayer(layer.name, layer.season)}
                      icon={<ToggleOffOutlinedIcon />}
                      checkedIcon={<ToggleOnOutlinedIcon style={{ color: '#a65e44' }} />}
                    />
                  }
                />
              </div>

              <div className="ifr-sub-menu">
                {props.clientName in layer && !layer.name.includes('LMP Polygon Level')
                  ? 'season' in layer
                    ? layer[props.clientName][layer.season.toLowerCase()].map((values, subIndex) => (
                        <div className="saavi-switch" key={values.value}>
                          <FormControlLabel
                            style={{ marginLeft: '15px', marginRight: '0px', alignSelf: 'center' }}
                            control={
                              <Checkbox
                                name={layer.name}
                                size="small"
                                color="primary"
                                icon={
                                  'img' in values ? (
                                    <img
                                      src={values.img}
                                      style={{
                                        width: '15px',
                                        height: '15px',
                                        filter: ' grayscale(100%)',
                                        marginTop: '0px',
                                      }}
                                    />
                                  ) : (
                                    <OfflineBoltIcon style={{ fontSize: '15px' }} />
                                  )
                                }
                                checkedIcon={
                                  'img' in values ? (
                                    <img src={values.img} style={{ width: '15px', height: '15px', marginTop: '0px' }} />
                                  ) : (
                                    <OfflineBoltIcon style={{ fontSize: '15px', color: values.color }} />
                                  )
                                }
                                onChange={checkBoxInterconnection(index, subIndex)}
                                value={values.value}
                              />
                            }
                          />
                          <label className="ifr-switch-label">{values.label}</label>
                        </div>
                      ))
                    : layer[props.clientName].map((values, subIndex) =>
                        layer.season in values ? (
                          <div className="saavi-switch" key={values.value}>
                            <FormControlLabel
                              style={{ marginLeft: '15px', marginRight: '0px', alignSelf: 'center' }}
                              control={
                                <Checkbox
                                  name={layer.name}
                                  size="small"
                                  color="primary"
                                  icon={
                                    'img' in values ? (
                                      <img
                                        src={values.img}
                                        style={{
                                          width: '15px',
                                          height: '15px',
                                          filter: ' grayscale(100%)',
                                          marginTop: '0px',
                                        }}
                                      />
                                    ) : (
                                      <OfflineBoltIcon style={{ fontSize: '15px' }} />
                                    )
                                  }
                                  checkedIcon={
                                    'img' in values ? (
                                      <img
                                        src={values.img}
                                        style={{ width: '15px', height: '15px', marginTop: '0px' }}
                                      />
                                    ) : (
                                      <OfflineBoltIcon style={{ fontSize: '15px', color: values.color }} />
                                    )
                                  }
                                  onChange={checkBoxInterconnection(index, subIndex)}
                                  value={values.value}
                                />
                              }
                            />
                            <label className="ifr-switch-label">{values.label}</label>
                          </div>
                        ) : (
                          <div className="saavi-switch" key={values.value}>
                            <FormControlLabel
                              style={{ marginLeft: '15px', marginRight: '0px', alignSelf: 'center' }}
                              control={
                                <Checkbox
                                  name={layer.name}
                                  size="small"
                                  color="primary"
                                  icon={
                                    'img' in values ? (
                                      <img
                                        src={values.img}
                                        style={{
                                          width: '15px',
                                          height: '15px',
                                          filter: ' grayscale(100%)',
                                          marginTop: '0px',
                                        }}
                                      />
                                    ) : (
                                      <OfflineBoltIcon style={{ fontSize: '15px' }} />
                                    )
                                  }
                                  checkedIcon={
                                    'img' in values ? (
                                      <img
                                        src={values.img}
                                        style={{ width: '15px', height: '15px', marginTop: '0px' }}
                                      />
                                    ) : (
                                      <OfflineBoltIcon style={{ fontSize: '15px', color: values.color }} />
                                    )
                                  }
                                  onChange={props.checkBox(index, subIndex)}
                                  value={values.value}
                                />
                              }
                            />
                            <label className="ifr-switch-label">{values.label}</label>
                          </div>
                        ),
                      )
                  : 'season' in layer
                  ? layer[props.clientName][layer.season.toLowerCase()].map((values, subIndex) => (
                      <div
                        className="saavi-switch"
                        key={values.value}
                        style={{ visibility: 'hidden', position: 'absolute' }}
                      >
                        <FormControlLabel
                          style={{ marginLeft: '15px', marginRight: '0px', alignSelf: 'center' }}
                          control={
                            <Checkbox
                              name={layer.name}
                              size="small"
                              color="primary"
                              icon={
                                'img' in values ? (
                                  <img
                                    src={values.img}
                                    style={{
                                      width: '15px',
                                      height: '15px',
                                      filter: ' grayscale(100%)',
                                      marginTop: '0px',
                                    }}
                                  />
                                ) : (
                                  <OfflineBoltIcon style={{ fontSize: '15px' }} />
                                )
                              }
                              checkedIcon={
                                'img' in values ? (
                                  <img src={values.img} style={{ width: '15px', height: '15px', marginTop: '0px' }} />
                                ) : (
                                  <OfflineBoltIcon style={{ fontSize: '15px', color: values.color }} />
                                )
                              }
                              onChange={checkBoxInterconnection(index, subIndex)}
                              value={values.value}
                            />
                          }
                        />
                        <label className="ifr-switch-label">{values.label}</label>
                      </div>
                    ))
                  : null}

                {layer.name === 'LMP Polygon Level ' ? (
                  <div>
                    {layer.season.toLowerCase() === 'summer' ? (
                      <SeasonSlider
                        layers={layer[props.clientName].summer}
                        classes={classes}
                        slider={sliderCongestionS}
                        sliderValue={sliderCPSummer}
                        setSliderValue={setSliderCPSummer}
                        // step={0.01}
                        min={38}
                        max={233}
                        title={'USD/MWh'}
                        units={[]}
                        reset={[40, 50]}
                        heatmap={generalHeatmap}
                        onChangeAfter={() =>
                          generalHeatmap(sliderCPSummer[0], sliderCPSummer[1], layer[props.clientName].summer)
                        }
                      />
                    ) : (
                      <SeasonSlider
                        layers={layer[props.clientName].winter}
                        classes={classes}
                        slider={sliderCongestionW}
                        sliderValue={sliderCPWinter}
                        setSliderValue={setSliderCPWinter}
                        // step={0.01}
                        min={23}
                        max={157}
                        title={'USD/MWh'}
                        units={[]}
                        reset={[30, 45]}
                        heatmap={generalHeatmap}
                        onChangeAfter={() =>
                          generalHeatmap(sliderCPWinter[0], sliderCPWinter[1], layer[props.clientName].winter)
                        }
                      />
                    )}
                  </div>
                ) : layer.name === 'LMP Node Level ' ? (
                  <div>
                    {layer.season.toLowerCase() === 'summer' ? (
                      <SeasonSlider
                        layers={layer[props.clientName].summer}
                        classes={classes}
                        slider={sliderLMPS}
                        sliderValue={sliderLMPSummer}
                        setSliderValue={setSliderLMPSummer}
                        // step={0.01}
                        min={0}
                        max={235}
                        title={'USD/MWh'}
                        units={[]}
                        reset={[40, 50]}
                        heatmap={generalHeatmap}
                        onChangeAfter={() =>
                          generalHeatmap(sliderLMPSummer[0], sliderLMPSummer[1], layer[props.clientName].summer)
                        }
                      />
                    ) : (
                      <SeasonSlider
                        layers={layer[props.clientName].winter}
                        classes={classes}
                        slider={sliderLMPW}
                        sliderValue={sliderLMPWinter}
                        setSliderValue={setSliderLMPWinter}
                        // step={0.01}
                        min={16}
                        max={158}
                        title={'USD/MWh'}
                        units={[]}
                        reset={[30, 45]}
                        heatmap={generalHeatmap}
                        onChangeAfter={() =>
                          generalHeatmap(sliderLMPWinter[0], sliderLMPWinter[1], layer[props.clientName].winter)
                        }
                      />
                    )}
                  </div>
                ) : (
                  <div>
                    {layer.season && layer.season.toLowerCase() === 'summer' ? (
                      <SeasonSlider
                        layers={layer[props.clientName].summer}
                        classes={classes}
                        slider={sliderCongestionNodeS}
                        sliderValue={sliderNCPSummer}
                        setSliderValue={setSliderNCPSummer}
                        step={0.01}
                        min={-2}
                        max={31}
                        title={'USD/MWh'}
                        units={[]}
                        reset={[-0.25, 2.75]}
                        heatmap={generalHeatmap}
                        onChangeAfter={() =>
                          generalHeatmap(sliderNCPSummer[0], sliderNCPSummer[1], layer[props.clientName].summer)
                        }
                      />
                    ) : (
                      <SeasonSlider
                        layers={layer[props.clientName].winter}
                        classes={classes}
                        slider={sliderCongestionNodeW}
                        sliderValue={sliderNCPWinter}
                        setSliderValue={setSliderNCPWinter}
                        step={0.01}
                        min={-8}
                        max={13}
                        title={'USD/MWh'}
                        units={[]}
                        reset={[-4.75, 3.0]}
                        heatmap={generalHeatmap}
                        onChangeAfter={() =>
                          generalHeatmap(sliderNCPWinter[0], sliderNCPWinter[1], layer[props.clientName].winter)
                        }
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </form>
      </div>
    </Grow>
  )
}

export default Interconnections
